import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
   API_URL,
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const SuperadminReportsActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'), 
};




// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/Reports/constants/ApiConstants.js